<template>
    <div class="main-header">
        <div class="icon-text-header">
            <div class="icon-div">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="380"
                    height="380"
                    viewBox="0 0 480 480"
                    fill="none"
                    class="pattern"
                    opacity="0.4"
                >
                    <defs>
                        <clipPath id="clip-circle"><rect x="190" y="190" width="240" height="240" /></clipPath>
                    </defs>
                    <g clip-path="url(#clip-circle)">
                        <circle cx="240" cy="240" r="60" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="92" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="124" stroke="#E4E4E7" />
                        <circle cx="240" cy="240" r="156" stroke="#E4E4E7" />
                    </g>
                </svg>
                <PhWarning :size="24" class="text-red-600" />
            </div>
            <h2>Delete Account</h2>
        </div>
    </div>
</template>

<script setup lang="ts">
defineEmits<{
    closeDialog: [];
}>();
</script>

<style lang="scss" scoped>
.main-header {
    @apply flex items-center justify-between px-6 pt-6 pb-5;
}
.icon-text-header {
    @apply flex items-center gap-3;

    h2 {
        @apply text-lg font-semibold text-gray-900 font-inter;
    }
}
.icon-div {
    @apply w-12 h-12 bg-red-100 rounded-full flex items-center justify-center relative;
}
.pattern {
    @apply absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none;
}
</style>